const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const raSuitabilityTestActions = require('../../actions/RASuitabilityTest');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');
const raSimulationActions = require('../../actions/RASimulation');

const { EVIDENCE_WEALTH_ROBO_HIRING } = require('constants/flagBasedFeatures');

class RAHireWrapperView extends React.Component {
    componentDidMount() {
        const {
            fetchMyInvestments,
            getTestResult,
            getPDFContract,
            history,
            requestPortfolioDistribution,
            immBrokerMyInvestments,
            immManagementPlan,
            match: {
                params: { objective },
            },
            immFlagBasedFeatures,
        } = this.props;
        getTestResult();
        !immFlagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING) &&
            getPDFContract(history, !__CONTACT_CENTER__);
        requestPortfolioDistribution();
        if (!immManagementPlan.get('isSavingSimulation')) {
            this.props.requestSimulation(!objective);
        }

        if (
            !immBrokerMyInvestments.get('isFetching') &&
            !immBrokerMyInvestments.get('fetchSuccess')
        ) {
            fetchMyInvestments();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immManagementPlan,
            match: {
                params: { objective },
            },
        } = this.props;
        const immPrevManagementPlan = prevProps.immManagementPlan;
        const finishedFetching =
            immManagementPlan.get('saveSuccess') &&
            !immPrevManagementPlan.get('saveSuccess');

        if (finishedFetching) {
            this.props.requestSimulation(
                objective !== 'objective' &&
                    !window.location.pathname.includes('/objective'),
            );
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetSuitabilityTest();
        this.props.restValueOfObjective();
    }

    render() {
        return this.props.children;
    }
}

RAHireWrapperView.propTypes = {
    children: PropTypes.any,
    fetchMyInvestments: PropTypes.func.isRequired,
    getPDFContract: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    match: PropTypes.object,
    requestPortfolioDistribution: PropTypes.func.isRequired,
    requestSimulation: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetSuitabilityTest: PropTypes.func.isRequired,
    restValueOfObjective: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        immBrokerMyInvestments: state.brokerMyInvestments,
        immManagementPlan: state.raManagementPlan,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        getPDFContract: raHireManagementPlanActions.getPDFContract,
        getTestResult: raSuitabilityTestActions.getTestResult,
        resetSuitabilityTest: raSuitabilityTestActions.reset,
        restValueOfObjective: raHireManagementPlanActions.restValueOfObjective,
        requestSimulation: raSimulationActions.requestSimulation,
        reset: raHireManagementPlanActions.reset,
        requestPortfolioDistribution:
            portfolioDistributionActions.requestPortfolioDistribution,
    },
)(withRouter(RAHireWrapperView));
